export let ShiftTradeEmployerRoutes = {
    "/shift-trading": {
        "name": "schedule.shift-trading",
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("./shift-trade.module.js");
                }
            }
        ]
    },
};